/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDomain } from './CRSFSecReviewDomain';
import {
    CRSFSecReviewDomainFromJSON,
    CRSFSecReviewDomainFromJSONTyped,
    CRSFSecReviewDomainToJSON,
} from './CRSFSecReviewDomain';

/**
 * 
 * @export
 * @interface CRSFSecReviewDomainPagedResponse
 */
export interface CRSFSecReviewDomainPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewDomain>}
     * @memberof CRSFSecReviewDomainPagedResponse
     */
    results?: Array<CRSFSecReviewDomain>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainPagedResponse interface.
 */
export function instanceOfCRSFSecReviewDomainPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewDomainPagedResponseFromJSON(json: any): CRSFSecReviewDomainPagedResponse {
    return CRSFSecReviewDomainPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewDomainFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewDomainPagedResponseToJSON(value?: CRSFSecReviewDomainPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewDomainToJSON)),
        'total': value.total,
    };
}

